import React, { useEffect, useRef, useState } from "react";
import i18n from "i18next";

import authService from "../../api-authorization/AuthorizeService";
import { fetchWrapper } from "../../../helpers/fetchwrapper";

// Fabric Imports
import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";
import CookieBanner from "../CookieBanner/CookieBanner";
import {
  Link,
  MessageBar,
  MessageBarBody,
  Image,
} from "@fluentui/react-components";
import {
  BoxMultipleSearchFilled,
  BoxMultipleSearchRegular,
  HatGraduationFilled,
  HatGraduationRegular,
  SettingsFilled,
  SettingsRegular,
  WrenchScrewdriverFilled,
  WrenchScrewdriverRegular,
} from "@fluentui/react-icons";
import Header from "../Header";
import HomeCard from "./HomeCard";

interface IHomeProps {}

function Home(props: IHomeProps) {
  const windowSize = useWindowSize();
  const [benutzer, setBenutzer] = useState();
  const [roles, setRoles] = useState<string[] | undefined>(undefined);
  const [requestedRoles, setRequestedRoles] = useState<any[] | undefined>(
    undefined
  );

  const [itemMaxWidth, setItemMaxWidth] = useState(0);

  const ref = useRef<any>(undefined);

  const size = useWindowSize();

  useEffect(() => {
    if (ref != null) {
      if (ref.current?.clientWidth < 450) {
        setItemMaxWidth((ref.current?.clientWidth - 10) / 2);
      } else if (
        ref.current?.clientWidth >= 450 &&
        ref.current?.clientWidth < 600
      ) {
        setItemMaxWidth((ref.current?.clientWidth - 20) / 3);
      } else if (
        ref.current?.clientWidth >= 600 &&
        ref.current?.clientWidth < 800
      ) {
        setItemMaxWidth((ref.current?.clientWidth - 30) / 4);
      } else {
        setItemMaxWidth((ref.current?.clientWidth - 40) / 5);
      }
    }
  }, [size]);

  const lang = i18n.language.includes("de") ? "DE" : "EN";

  const getUser = () => {
    authService.getUser().then((user: any) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result) => {
            setBenutzer(result);
            // Bin eingeloggt, wir können die Rollen des Benutzers abfragen:
            fetchWrapper
              .getWithAuth(`${baseUrl}/api/account/getmyroles`)
              .then((result) => {
                setRoles(result);
              })
              .catch((error) => {});

            fetchWrapper
              .getWithAuth(`${baseUrl}/api/account/GetMyRequestedRoles`)
              .then((result) => {
                setRequestedRoles(result);
              })
              .catch((error) => {});
          });
      }
    });
  };

  useEffect(() => {
    getUser();
  }, []);

  const disableToolbox =
    roles != undefined &&
    roles.includes("Partner") &&
    !roles.includes("Toolbox");

  return (
    <div ref={ref}>
      <CookieBanner />
      <Header />
      <div className="lueb-ImageBlock">
        {lang == "DE" && (
          <Image
            alt="TITELBILD DE"
            className="lueb-ImageRounded"
            src={`${baseUrl}/IMAGES/HOME/TITELBILD_DE.png`}
          />
        )}
        {lang == "EN" && (
          <img
            alt="TITELBILD EN"
            className="lueb-ImageRounded"
            src={`${baseUrl}/IMAGES/HOME/TITELBILD_EN.png`}
          ></img>
        )}
      </div>
      {roles && roles.length == 1 && roles[0].toLowerCase() == "demo" && (
        <div className="lueb-ImageBlock">
          <MessageBar intent={"warning"}>
            <MessageBarBody>
              {i18n.t<string>("demoAccountWarning")}
              <Link
                style={{ marginLeft: "5px" }}
                href="mailto:digital@luebbering.de?subject=Lübbering Digital - Account not activated"
                target="_blank"
              >
                {i18n.t<string>("contactUs")}
              </Link>
            </MessageBarBody>
          </MessageBar>
        </div>
      )}
      {/* <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}> */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          marginTop: "10px",
        }}
      >
        <HomeCard
          forceDisable={false}
          modulName="Configurator"
          name="L.SP3 Configurator"
          hasRole={roles && roles.includes("Configurator")}
          hasRequested={
            requestedRoles &&
            requestedRoles.some((item) => item.toLowerCase() == "configurator")
          }
          isLoggedIn={benutzer ? true : false}
          targetUrl="/configuratorst"
          mainImgUrl={`${baseUrl}/IMAGES/HOME/CONFIGURATOR1_${lang}.JPG`}
          secondImgUrl={`${baseUrl}/IMAGES/HOME/CONFIGURATOR3_${lang}.JPG`}
          thirdImgUrl={`${baseUrl}/IMAGES/HOME/CONFIGURATOR4_${lang}.JPG`}
          roleRequested={() => {
            getUser();
          }}
          filledIcon={<SettingsFilled fontSize={24} color={"#ff6600"} />}
          regularIcon={<SettingsRegular fontSize={24} color={"black"} />}
        />

        <HomeCard
          modulName="Catalog"
          name="Quick Finder"
          forceDisable={false}
          hasRole={roles && roles.includes("Catalog")}
          hasRequested={
            requestedRoles &&
            requestedRoles.some((item) => item.toLowerCase() == "catalog")
          }
          isLoggedIn={benutzer ? true : false}
          targetUrl="/quickfinder"
          mainImgUrl={`${baseUrl}/IMAGES/HOME/QUICKFINDER1_${lang}.JPG`}
          secondImgUrl={`${baseUrl}/IMAGES/HOME/QUICKFINDER2_${lang}.JPG`}
          thirdImgUrl={`${baseUrl}/IMAGES/HOME/QUICKFINDER3_${lang}.JPG`}
          roleRequested={() => {
            getUser();
          }}
          filledIcon={
            <BoxMultipleSearchFilled fontSize={24} color={"#ff6600"} />
          }
          regularIcon={
            <BoxMultipleSearchRegular fontSize={24} color={"black"} />
          }
        />

        <HomeCard
          modulName="toolbox"
          name="My Toolbox"
          hasRole={roles && roles.includes("Toolbox")}
          forceDisable={disableToolbox}
          hasRequested={
            requestedRoles &&
            requestedRoles.some((item) => item.toLowerCase() == "toolbox")
          }
          isLoggedIn={benutzer ? true : false}
          targetUrl="/mytoolbox"
          mainImgUrl={`${baseUrl}/IMAGES/HOME/TOOLBOX.PNG`}
          secondImgUrl={`${baseUrl}/IMAGES/HOME/MYTOOLBOX1_DE.JPG`}
          thirdImgUrl={`${baseUrl}/IMAGES/HOME/MYTOOLBOX2_DE.JPG`}
          roleRequested={() => {
            getUser();
          }}
          filledIcon={
            <WrenchScrewdriverFilled fontSize={24} color={"#ff6600"} />
          }
          regularIcon={
            <WrenchScrewdriverRegular fontSize={24} color={"black"} />
          }
        />

        <HomeCard
          modulName="Academy"
          name="Academy"
          forceDisable={false}
          hasRole={roles && roles.includes("Academy")}
          hasRequested={
            requestedRoles &&
            requestedRoles.some((item) => item.toLowerCase() == "academy")
          }
          isLoggedIn={benutzer ? true : false}
          targetUrl="/academy"
          mainImgUrl={`${baseUrl}/IMAGES/HOME/ACADEMY.PNG`}
          secondImgUrl={`${baseUrl}/IMAGES/HOME/ACADEMY2_DE.JPG`}
          thirdImgUrl={`${baseUrl}/IMAGES/HOME/ACADEMY3_DE.JPG`}
          roleRequested={() => {
            getUser();
          }}
          filledIcon={<HatGraduationFilled fontSize={24} color={"#ff6600"} />}
          regularIcon={<HatGraduationRegular fontSize={24} color={"black"} />}
        />

        <HomeCard
          modulName="partner"
          name="Partner Lounge"
          hasRole={roles && roles.includes("Partner")}
          forceDisable={
            roles != undefined &&
            roles.includes("Toolbox") &&
            !roles.includes("Partner")
          }
          hasRequested={
            requestedRoles &&
            requestedRoles.some((item) => item.toLowerCase() == "partner")
          }
          isLoggedIn={benutzer ? true : false}
          targetUrl="/partnerlounge"
          mainImgUrl={`${baseUrl}/IMAGES/HOME/PARTNERLOUNGE.PNG`}
          secondImgUrl={`${baseUrl}/IMAGES/HOME/PARTNERLOUNGE2_EN.JPG`}
          thirdImgUrl={`${baseUrl}/IMAGES/HOME/PARTNERLOUNGE3_EN.JPG`}
          roleRequested={() => {
            getUser();
          }}
          filledIcon={
            <WrenchScrewdriverFilled fontSize={24} color={"#ff6600"} />
          }
          regularIcon={
            <WrenchScrewdriverRegular fontSize={24} color={"black"} />
          }
        />
        {windowSize.width <= 1165 && (
          <div style={{ width: "100%", maxWidth: "260px" }}></div>
        )}
      </div>
      {/* </StackShim> */}
    </div>
  );
}

export default Home;
